import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lg:h-[80px] h-[50px]" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl md:text-6xl uppercase text-center font-bold opacity-100" }, "Services")
], -1)
const _hoisted_5 = { class: "container max-w-[1024px]" }
const _hoisted_6 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[20px]" }
const _hoisted_7 = { class: "container relative w-full md:mt-[10px] mt-[10px] md:mb-[50px] mb-[20px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl my-[20px] font-bold text-center text-cyan-700 uppercase" }, " services ", -1)
const _hoisted_9 = { class: "w-full flex relative" }
const _hoisted_10 = { class: "my-[20px] w-full flex relative justify-center items-center flex-wrap" }

import HeaderComponent from '../components/HeaderComponent.vue'
  import carouselBranding from '../components/CarouselBranding.vue'
  import One_service from '../components/One_service.vue'
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
import FooterComponent from '@/components/FooterComponent.vue';
  const initialSlide = 2;
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'servicesFCe',
  setup(__props) {

  const router = useRouter()
  function goToIndividualPage() {
      router.push('/services')
  }
  function goToCompaniePage() {
      router.push('/servicesFC')
  }
  function goToCompanieEPage() {
      router.push('/servicesFCe')
  }
  function goToCompanieAPage() {
      router.push('/servicesFCa')
  }
  function goToMPMEPage() {
      router.push('/servicesMPME')
  }
  const pageTitle = ref('IronSecur | Nos services'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
  const services = ref([
  {   name: 's7_name', 
      image: '/img/service7.jpg', 
      description: 's7_description', 
      key: ["s7_key1", "s7_key2", "s7_key3", "s7_key4", "s7_key5"] 

  },
  {   name: 's8_name', 
      image: '/img/service8.jpg', 
      description: 's8_description', 
      key: ["s8_key1", "s8_key2", "s8_key3", "s8_key4", "s8_key5"] 

  },
  
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(carouselBranding, { "initial-slide": initialSlide }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToIndividualPage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/services'
              })
            }, _toDisplayString(_ctx.$t('FI')), 3),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToCompaniePage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/servicesFCe'
              })
            }, _toDisplayString(_ctx.$t('FOC')), 3),
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToMPMEPage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/servicesMPME'
              })
            }, _toDisplayString(_ctx.$t('MPME')), 3)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: goToCompaniePage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFC'
              })
            }, _toDisplayString(_ctx.$t('SDE')), 3),
            _createElementVNode("button", {
              onClick: goToCompanieEPage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFCe'
              })
            }, _toDisplayString(_ctx.$t('EVA')), 3),
            _createElementVNode("button", {
              onClick: goToCompanieAPage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFCa'
              })
            }, _toDisplayString(_ctx.$t('ALL')), 3)
          ]),
          _createVNode(One_service, { services: services.value }, null, 8, ["services"])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})